"use client";

import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";

import { LogoutButton as AuthLogoutButton } from "@/components/auth/LogoutButton";
import { ProfileWrapper } from "@/components/profile/ProfileWrapper";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export const LogoutButton = () => {
    const t = useTranslations("profile");

    const [ mounted, setMounted ] = useState(false);

    useEffect(() => setMounted(true), []);

    return (
        <AuthLogoutButton>
            <Card className="bg-accent">
                <CardContent className="p-4">
                    {!mounted ? (
                        <Skeleton className="h-[28px] w-full" />
                    ) : (
                        <ProfileWrapper currentValue={ t("logout") }></ProfileWrapper>
                    )}
                </CardContent>
            </Card>
        </AuthLogoutButton>
    );
};